import React, { useEffect, useState } from "react";
import "./userManagement.css";
import PrettyContainer from "../../prettyContainer/PrettyContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faKey,
  faLock,
  faLockOpen,
  faUserLock,
  faPowerOff,
  faEraser,
  faScrewdriverWrench,
  faSort,
  faSortUp,
  faSortDown,
  faUserShield,
  faClockRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getRemaining } from "../../../helpers/dueDate";
import { Alert, Badge, Button, Modal, Spinner } from "react-bootstrap";
import AddUser from "../../addUser/AddUser";
import UpdatePassword from "../../updatePassword/UpdatePassword";
import UpdateApplications from "../../updateApplications/UpdateApplications";
import {
  clearUserUUIDs,
  deleteSpecificUser,
  getAllApplications,
  getCreators,
  getUsers,
  updateInfoToUser,
  getCascadeCount,
  blockAdminCascade,
  unblockAdminCascade,
  getAppBlocks,
  setAppBlock,
} from "../../../helpers/api";
import { getUser as getLoggedUser } from "../../../helpers/localStorage";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const configSystem = require("../../../configApp");

export default function UserManagementPage() {
  const navigate = useNavigate();
  // Permite llegar ya filtrado desde la pestana Admins, igual que Access
  // History acepta ?user=. El valor es el _id del admin, que es lo mismo
  // que usa el desplegable de "Created By".
  const [searchParams] = useSearchParams();
  const loggedUser = getLoggedUser();
  const isSuperUser = loggedUser && (loggedUser.type === configSystem.roles.SUPER_USER || loggedUser.type === configSystem.roles.SUPER_ADMIN);

  const [applicationsConfig, setApplicationsConfig] = useState({"applications":[]});

  // Panel para apagar aplicaciones sueltas a un admin y a su gente.
  const [appsPanel, setAppsPanel] = useState({
    show: false,
    admin: null,
    datos: null,
    cargando: false,
    error: "",
  });
  const [creators, setCreators] = useState([]);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const LIMIT = 20;
  const [search, setSearch] = useState({ keywords: "", toggleSearch: false, dueDate: null, dueDateOperator : "lt", dueDateSort: 0, enabledBy:"", enabled: "-1", createdById: searchParams.get("createdBy") || "", application: "", page: 1, limit: 20 });
  const [showLoading, setShowLoading] = useState(false);
  const [connectionSuccess, setConnectionSuccess] = useState("");
  const [connectionError, setConnectionError] = useState("");
  const actionRef = {
    clearUUID: 0,
    unlockUser: 1,
    lockUser: 2,
    deleteUser: 3,
    changeRole: 4,
    blockCascade: 5,
    unblockCascade: 6,
  };

  const forceSearch = () => {
    setSearch({ ...search, toggleSearch: !search.toggleSearch });
  };

  const goToPage = (newPage) => {
    setPage(newPage);
    setSearch({ ...search, page: newPage });
  };

  useEffect(() => {
    setIsLoading(true);
    const timeoutId = setTimeout(() => {
      getUsers(search)
        .then((data) => {
          setUsers(data.users || []);
          setTotalPages(data.totalPages || 1);
          setTotalUsers(data.total || 0);
          setPage(data.page || 1);
          setIsLoading(false);
        })
        .catch((errors) => {
          console.log(errors);
          setIsLoading(false);
        });
    }, 200);

    return () => clearTimeout(timeoutId);
  }, [search]);

  useEffect(()=>{
        getAllApplications().then((data)=>{
          setApplicationsConfig(data);
        }).catch((e)=>{
          console.log(e);
        });
    },[]);

  useEffect(()=>{
    if (isSuperUser) {
      getCreators().then((data) => {
        setCreators(data);
      }).catch((e) => {
        console.log(e);
      });
    }
  },[]);

  const handleSearchKeyWords = (e) => {
    e.preventDefault();
    setSearch({ ...search, keywords: e.target.value, page: 1 });
    setPage(1);
  };

  const handleSearchDueDate = (dueDate) => {
    setSearch({ ...search, dueDate: dueDate, page: 1 });
    setPage(1);
  };

  const handleDueDateSort = (sortDirection) => {
    setSearch({...search, dueDateSort: sortDirection, page: 1});
    setPage(1);
  }

  const handleDueDateOperator = (e) => {
    e.preventDefault();
    setSearch({...search, dueDateOperator: e.target.value, page: 1});
    setPage(1);
  }

  const handleEnabledUserBy = (e) => {
    e.preventDefault();
    setSearch({...search, enabledBy: e.target.value, page: 1});
    setPage(1);
  }

  const handleEnabledUser  = (e) => {
    e.preventDefault();
    setSearch({...search, enabled: e.target.value, page: 1});
    setPage(1);
  }

  // Filtrar por aplicacion: para ver quien tiene asignada una en concreto.
  const handleApplication = (e) => {
    e.preventDefault();
    setSearch({...search, application: e.target.value, page: 1});
    setPage(1);
  }

  const handleCreatedByRole = (e) => {
    e.preventDefault();
    setSearch({...search, createdById: e.target.value, page: 1});
    setPage(1);
  }

  const [showAddNewUSer, setShowAddNewUser] = useState(false);
  const [showUpdatePassword, setShowUpdatePassword] = useState({
    show: false,
    user: { username: "" },
  });
  const [showUpdateApplications, setShowUpdateApplications] = useState({
    show: false,
    user: { username: "" },
  });
  const [modalInfo, setModalInfo] = useState({
    user: {},
    show: false,
    tittle: "",
    body: "",
    confirm: () => {},
    cancel: () => {},
    action: -1,
  });

  useEffect(() => {
    if (!modalInfo.show) {
      setConnectionSuccess("");
      setConnectionError("");
    }
  }, [modalInfo]);

  const handleCancelNewUser = () => setShowAddNewUser(false);
  const handleShowNewUser = () => setShowAddNewUser(true);
  const handleCancelUpdatePassword = () =>
    setShowUpdatePassword({ ...showUpdatePassword, show: false });
  const handleCancelUpdateApplications = () =>
    setShowUpdateApplications({ ...showUpdateApplications, show: false });
  const handleShowUpdatePassword = (info) => setShowUpdatePassword(info);

  const handleModalInfo = (info) => {
    setModalInfo({ ...modalInfo, ...info });
  };

  const handleUpdateApplications = (info) => {
    setShowUpdateApplications(info);
  };

  const handlerActions = (e) => {
    e.preventDefault();
    switch (modalInfo.action) {
      case actionRef.clearUUID:
        clearRegisteredBrowser();
        break;
      case actionRef.deleteUser:
        deleteUser();
        break;
      case actionRef.unlockUser:
        unlockUser(true);
        break;
      case actionRef.lockUser:
        unlockUser(false);
        break;
      case actionRef.changeRole:
        changeRole();
        break;
      case actionRef.blockCascade:
        aplicarCascada(true);
        break;
      case actionRef.unblockCascade:
        aplicarCascada(false);
        break;
      default:
        break;
    }
  };
  const deleteUser = () => {
    setShowLoading(true);
    setConnectionError("");
    setConnectionSuccess("");
    
    deleteSpecificUser(modalInfo.user)
      .then((response) => {
        setShowLoading(false);
        setConnectionError("");
        setConnectionSuccess(response.message || "User deleted successfully");
        
        // Refresh the user list
        forceSearch();
        
        // Close modal after 1.5 seconds
        setTimeout(() => {
          setConnectionSuccess("");
          handleCloseModal();
        }, 1500);
      })
      .catch((error) => {
        setShowLoading(false);
        setConnectionError(error || "Error deleting user");
        setConnectionSuccess("");
        
        // Clear error message after 5 seconds
        setTimeout(() => {
          setConnectionError("");
        }, 5000);
      });
  };
  // Bloquea (o desbloquea) a un admin limitado junto con los usuarios que el
  // creo. El detalle de a quien alcanza lo decide el servidor; aqui solo se
  // pide y se ensena el resultado.
  const aplicarCascada = (bloquear) => {
    setShowLoading(true);
    setConnectionError("");
    setConnectionSuccess("");

    const accion = bloquear ? blockAdminCascade : unblockAdminCascade;

    accion(modalInfo.user._id)
      .then((response) => {
        setShowLoading(false);
        let aviso = response.message;
        // Si alguno se quedo fuera por fecha vencida hay que decirlo, o parece
        // que el boton no funciono del todo.
        if (!bloquear && response.vencidos > 0) {
          aviso += ` — ${response.vencidos} siguen apagados por fecha vencida`;
        }
        setConnectionSuccess(aviso);
        forceSearch();
      })
      .catch((error) => {
        setShowLoading(false);
        setConnectionError(error);
      });

    handleModalInfo({ show: false });
  };

  // Pregunta al servidor a cuanta gente va a afectar y recien ahi abre la
  // confirmacion. Avisar despues de pulsar no sirve de nada.
  const preguntarCascada = (user, bloquear) => {
    getCascadeCount(user._id)
      .then((datos) => {
        const cuantos = bloquear ? datos.bloqueables : datos.desbloqueables;
        handleModalInfo({
          user: user,
          show: true,
          tittle: bloquear
            ? `Block ${user.username} and its users`
            : `Unblock ${user.username} and its users`,
          body: bloquear
            ? `This blocks ${user.username} and ${cuantos} user(s) it created. Users already disabled for other reasons are left untouched.`
            : `This unblocks ${user.username} and the ${cuantos} user(s) that fell with it. Anyone disabled for a different reason, or past their due date, stays disabled.`,
          action: bloquear ? actionRef.blockCascade : actionRef.unblockCascade,
        });
      })
      .catch((error) => setConnectionError(error));
  };

  const abrirAppsPanel = (user) => {
    setAppsPanel({ show: true, admin: user, datos: null, cargando: true, error: "" });
    getAppBlocks(user._id)
      .then((datos) => setAppsPanel((p) => ({ ...p, datos, cargando: false })))
      .catch((e) => setAppsPanel((p) => ({ ...p, cargando: false, error: e })));
  };

  // Apaga o enciende una aplicacion para ese admin y todos sus usuarios.
  const alternarApp = (idApp, bloquear) => {
    const admin = appsPanel.admin;
    setAppsPanel((p) => ({ ...p, cargando: true, error: "" }));

    setAppBlock(admin._id, idApp, bloquear)
      .then((r) => {
        setAppsPanel((p) => ({
          ...p,
          cargando: false,
          datos: { ...p.datos, blockedApplications: r.blockedApplications },
        }));
        setConnectionSuccess(r.message);
        forceSearch();
      })
      .catch((e) => setAppsPanel((p) => ({ ...p, cargando: false, error: e })));
  };

  const unlockUser = (value) => {
    setShowLoading(true);
    setConnectionError("");
    setConnectionSuccess("");
    
    updateInfoToUser(modalInfo.user, { enabled: value })
      .then((response) => {
        setShowLoading(false);
        setConnectionError("");
        setConnectionSuccess(response.message || `User ${value ? 'unlocked' : 'locked'} successfully`);
        
        // Refresh the user list
        forceSearch();
        
        // Close modal after 1.5 seconds
        setTimeout(() => {
          setConnectionSuccess("");
          handleCloseModal();
        }, 1500);
      })
      .catch((error) => {
        setShowLoading(false);
        setConnectionError(error || "Error updating user status");
        setConnectionSuccess("");
        
        // Clear error message after 5 seconds
        setTimeout(() => {
          setConnectionError("");
        }, 5000);
      });
  };
  const clearRegisteredBrowser = (e) => {
    setShowLoading(true);
    setConnectionError("");
    setConnectionSuccess("");
    
    clearUserUUIDs(modalInfo.user)
      .then((response) => {
        setShowLoading(false);
        setConnectionError("");
        setConnectionSuccess(response.message || "Browser data cleared successfully");
        
        // Close modal after 1.5 seconds
        setTimeout(() => {
          setConnectionSuccess("");
          handleCloseModal();
        }, 1500);
      })
      .catch((error) => {
        setShowLoading(false);
        setConnectionError(error || "Error clearing browser data");
        setConnectionSuccess("");
        
        // Clear error message after 5 seconds
        setTimeout(() => {
          setConnectionError("");
        }, 5000);
      });
  };

  const handleCloseModal = () => {
    setConnectionError("");
    setConnectionSuccess("");
    setShowLoading(false);
    handleModalInfo({ show: false });
  };

  const getRoleLabel = (type) => {
    switch (type) {
      case configSystem.roles.SUPER_ADMIN: return { label: "Super Admin", variant: "danger" };
      case configSystem.roles.SUPER_USER:  return { label: "Super User",  variant: "warning" };
      case configSystem.roles.ADMIN:       return { label: "Admin",        variant: "info" };
      default:                             return { label: "User",         variant: "secondary" };
    }
  };

  const changeRole = () => {
    setShowLoading(true);
    setConnectionError("");
    setConnectionSuccess("");

    updateInfoToUser(modalInfo.user, { type: modalInfo.newRole })
      .then((response) => {
        setShowLoading(false);
        setConnectionSuccess(response.message || "Role updated successfully");
        forceSearch();
        setTimeout(() => {
          setConnectionSuccess("");
          handleCloseModal();
        }, 1500);
      })
      .catch((error) => {
        setShowLoading(false);
        setConnectionError(error || "Error changing role");
        setTimeout(() => setConnectionError(""), 5000);
      });
  };

  const mapUsers = (users) => {
    return users.map((user, i) => {
      const roleInfo = getRoleLabel(user.type);
      const remaining = getRemaining(user.dueDate);
      return (
        <tr
          key={i}
          className={
            remaining.days !== null && remaining.days <= 10 ? "ig-row-expiring" : ""
          }
        >
          <td>{user.username}</td>
          <td>
            {moment(user.dueDate).format("YYYY-MM-DD HH:mm:ss")}
            <div className={`ig-remaining ig-remaining-${remaining.level}`}>
              {remaining.text}
            </div>
          </td>
          <td>
            {user.applications.map((app, i) => {
              let component = null;
              applicationsConfig.applications.forEach((appC) => {
                if (app === appC.id) {
                  component = (
                    <Badge key={i} bg="primary" style={{ marginRight: "4px" }}>
                      {appC.tittle}
                    </Badge>
                  );
                }
              });
              if (component !== null) {
                return component;
              }
            })}
          </td>
          <td>
            {user.enabled ? (
              <Badge bg="success">Active</Badge>
            ) : (
              <Badge bg="secondary">Inactive</Badge>
            )}
          </td>
          <td>
            <Badge bg={roleInfo.variant}>{roleInfo.label}</Badge>
          </td>

          <td className="ig-userManagement-table-actions-col">
            <span className="update-applications-user">
              <FontAwesomeIcon
                icon={faScrewdriverWrench}
                onClick={() => {
                  handleUpdateApplications({ show: true, user: user });
                }}
              />
            </span>
            {user.enabled ? (
              <span className="lock-user">
                <FontAwesomeIcon
                  icon={faLock}
                  onClick={() => {
                    handleModalInfo({
                      user: user,
                      show: true,
                      tittle: `Disable user ${user.username}`,
                      body: `Do you confirm action disable?`,
                      action: actionRef.lockUser,
                    });
                  }}
                />
              </span>
            ) : (
              <span className="unlock-user">
                <FontAwesomeIcon
                  icon={faLockOpen}
                  onClick={() => {
                    handleModalInfo({
                      user: user,
                      show: true,
                      tittle: `Enable User ${user.username}`,
                      body: `Do you confirm action enable?`,
                      action: actionRef.unlockUser,
                    });
                  }}
                />
              </span>
            )}

            {/* Solo para admins limitados: son los unicos que tienen usuarios
                propios (createdBy), y a los que aplica la cascada. */}
            {user.type === configSystem.roles.ADMIN && (
              <span
                className="cascade-user"
                title={
                  user.enabled
                    ? "Block this admin and its users"
                    : "Unblock this admin and its users"
                }
              >
                <FontAwesomeIcon
                  icon={faUserLock}
                  onClick={() => preguntarCascada(user, user.enabled)}
                />
              </span>
            )}

            {/* Apagar aplicaciones sueltas: solo tiene sentido en un admin
                limitado, que es quien tiene usuarios propios que heredan. */}
            {user.type === configSystem.roles.ADMIN && (
              <span className="apps-user" title="Turn applications on or off for this admin">
                <FontAwesomeIcon
                  icon={faPowerOff}
                  onClick={() => abrirAppsPanel(user)}
                />
              </span>
            )}

            <span className="clear-user">
              <FontAwesomeIcon
                icon={faEraser}
                onClick={(e) => {
                  handleModalInfo({
                    user: user,
                    show: true,
                    tittle: `Reset lock devices for ${user.username}`,
                    body: `Do you confirm action clear?`,
                    force: !modalInfo.force,
                    action: actionRef.clearUUID,
                  });
                }}
              />
            </span>
            <span className="key-user">
              <FontAwesomeIcon
                icon={faKey}
                onClick={() => {
                  handleShowUpdatePassword({ show: true, user: user });
                }}
              />
            </span>
            <span className="history-user" title="Access history">
              <FontAwesomeIcon
                icon={faClockRotateLeft}
                onClick={() => {
                  navigate(`/access-history?user=${encodeURIComponent(user.username)}`);
                }}
              />
            </span>
            <span className="delete-user">
              <FontAwesomeIcon
                icon={faTrash}
                onClick={() => {
                  handleModalInfo({
                    user: user,
                    show: true,
                    tittle: `Deleting User ${user.username}`,
                    body: `Do you confirm action delete?`,
                    action: actionRef.deleteUser,
                  });
                }}
              />
            </span>
            {isSuperUser && (
              <span className="role-user" title="Change Role">
                <FontAwesomeIcon
                  icon={faUserShield}
                  onClick={() => {
                    const nextRole = user.type === configSystem.roles.BASIC_CUSTOMER
                      ? configSystem.roles.ADMIN
                      : user.type === configSystem.roles.ADMIN
                        ? configSystem.roles.SUPER_USER
                        : configSystem.roles.BASIC_CUSTOMER;
                    const roleLabels = { [configSystem.roles.BASIC_CUSTOMER]: 'User', [configSystem.roles.ADMIN]: 'Admin', [configSystem.roles.SUPER_USER]: 'Super User' };
                    handleModalInfo({
                      user: user,
                      newRole: nextRole,
                      show: true,
                      tittle: `Change role for ${user.username}`,
                      body: `Change role from "${roleLabels[user.type]}" to "${roleLabels[nextRole]}"?`,
                      action: actionRef.changeRole,
                    });
                  }}
                />
              </span>
            )}
          </td>
          <td>{moment(user.createdAt).format("YYYY-MM-DD HH:mm:ss")}</td>
          {isSuperUser && (
            <td style={{ fontSize: "12px", color: "#555" }}>
              {user.createdBy
                ? (user.createdBy.username || user.createdBy)
                : <span style={{ color: "#aaa" }}>—</span>}
            </td>
          )}
        </tr>
      );
    });
  };

  const usersTable = () => (
    <PrettyContainer tittle="USER MANAGEMENT">
      <Button
        onClick={handleShowNewUser}
        style={{ position: "relative", left: "90%" }}
        variant="success"
      >
        Add New USer
      </Button>

      <table className="ig-userManagement-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Due Date</th>
            <th>Applications</th>
            <th>Status</th>
            <th>Role</th>
            <th>Actions</th>
            <th>Created At</th>
            {isSuperUser && <th>Created By</th>}
          </tr>
          <tr>
            <th>
              <input
                type="text"
                value={search.keywords}
                onChange={handleSearchKeyWords}
              ></input>
            </th>
            <th>
            <div style={{ display: "flex", alignItems: "center" }}>
              <select value={search.dueDateOperator} onChange={handleDueDateOperator}>
                <option value="lt">&lt;</option>
                <option value="gt">&gt;</option>
                <option value="eq">=</option>
              </select>
              <DatePicker
                selected={search.dueDate}
                onChange={(date) => handleSearchDueDate(date)}
                highlightDates={[moment.now()]}
                isClearable={true}
              />
  {search.dueDateSort === 0 ? (
    <FontAwesomeIcon
      icon={faSort}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        e.preventDefault();
        handleDueDateSort(1);
      }}
    />
  ) : search.dueDateSort === 1 ? (
    <FontAwesomeIcon
      icon={faSortUp}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        e.preventDefault();
        handleDueDateSort(-1);
      }}
    />
  ) : (
    <FontAwesomeIcon
      icon={faSortDown}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        e.preventDefault();
        handleDueDateSort(1);
      }}
    />
  )}
</div>
            
            
              

            </th>
            <th>
              {/* Filtro por aplicacion: se elige una y la lista queda con los
                  usuarios que la tienen asignada. Debajo sale cuantos son. */}
              <select
                value={search.application}
                onChange={handleApplication}
                style={{ maxWidth: "150px" }}
                title="Ver quien tiene esta aplicacion"
              >
                <option value="">All applications</option>
                {(applicationsConfig.applications || []).map((a) => (
                  <option key={a.id} value={a.id}>{a.tittle}</option>
                ))}
              </select>
              {search.application !== "" && !isLoading && (
                <div style={{ fontSize: "11px", color: "#0d6efd", marginTop: "2px" }}>
                  {totalUsers} {totalUsers === 1 ? "user has it" : "users have it"}
                </div>
              )}
            </th>
            <th><select value={search.enabled} onChange={handleEnabledUser}>
              <option value="-1"></option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            </th>
            <th></th>
            <th></th>
            {isSuperUser && (
              <th>
                <select value={search.createdById} onChange={handleCreatedByRole} style={{ maxWidth: "120px" }}>
                  <option value="">All</option>
                  {creators.map((c) => (
                    <option key={c._id} value={c._id}>{c.username}</option>
                  ))}
                </select>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={isSuperUser ? "8" : "7"} style={{ textAlign: 'center', padding: '40px' }}>
                <Spinner animation="border" role="status" variant="primary">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p style={{ marginTop: '10px', color: '#666' }}>Loading users...</p>
              </td>
            </tr>
          ) : users.length === 0 ? (
            <tr>
              <td colSpan={isSuperUser ? "8" : "7"} style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                No users found
              </td>
            </tr>
          ) : (
            mapUsers(users)
          )}
        </tbody>
      </table>

      {/* Pagination controls */}
      {!isLoading && totalPages > 1 && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginTop: "16px", flexWrap: "wrap" }}>
          <Button variant="outline-secondary" size="sm" onClick={() => goToPage(1)} disabled={page <= 1}>«</Button>
          <Button variant="outline-secondary" size="sm" onClick={() => goToPage(page - 1)} disabled={page <= 1}>‹ Prev</Button>
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter(p => p === 1 || p === totalPages || (p >= page - 2 && p <= page + 2))
            .reduce((acc, p, idx, arr) => {
              if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
              acc.push(p);
              return acc;
            }, [])
            .map((p, idx) =>
              p === "..." ? (
                <span key={`ellipsis-${idx}`} style={{ padding: "0 4px" }}>…</span>
              ) : (
                <Button key={p} variant={p === page ? "primary" : "outline-secondary"} size="sm" onClick={() => goToPage(p)}>{p}</Button>
              )
            )}
          <Button variant="outline-secondary" size="sm" onClick={() => goToPage(page + 1)} disabled={page >= totalPages}>Next ›</Button>
          <Button variant="outline-secondary" size="sm" onClick={() => goToPage(totalPages)} disabled={page >= totalPages}>»</Button>
          <span style={{ color: "#666", fontSize: "13px" }}>
            Page {page} of {totalPages} — {totalUsers} users
          </span>
        </div>
      )}
    </PrettyContainer>
  );

  const modalPopUp = () => {
    return (
      <>
        <Modal
          show={appsPanel.show}
          onHide={() => setAppsPanel({ show: false, admin: null, datos: null, cargando: false, error: "" })}
          centered={true}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "1.1rem" }}>
              Applications — {appsPanel.admin?.username}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {appsPanel.error !== "" && <Alert variant="warning">{appsPanel.error}</Alert>}

            <p style={{ fontSize: ".88rem", color: "#555" }}>
              Turning an application off blocks it for this admin
              {appsPanel.datos ? ` and its ${appsPanel.datos.alcanzados} users` : " and all its users"},
              including anyone they create later. They will see it as unavailable
              until you turn it back on.
            </p>

            {appsPanel.cargando && !appsPanel.datos ? (
              <div style={{ textAlign: "center", padding: "1.5rem" }}>
                <Spinner animation="border" size="sm" />
              </div>
            ) : appsPanel.datos ? (
              <div style={{ display: "flex", flexDirection: "column", gap: ".4rem" }}>
                {appsPanel.datos.applications.length === 0 && (
                  <span style={{ color: "#777", fontSize: ".9rem" }}>
                    This admin has no applications assigned.
                  </span>
                )}

                {appsPanel.datos.applications.map((idApp) => {
                  const meta = applicationsConfig.applications.find((a) => a.id === idApp);
                  const bloqueada = appsPanel.datos.blockedApplications.includes(idApp);
                  return (
                    <div
                      key={idApp}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: ".75rem",
                        padding: ".55rem .7rem",
                        border: "1px solid #e5e7eb",
                        borderRadius: "5px",
                        background: bloqueada ? "#fff7ed" : "#fff",
                      }}
                    >
                      <span style={{ fontWeight: 600, fontSize: ".92rem" }}>
                        {meta ? meta.tittle : `Application ${idApp}`}
                        {bloqueada && (
                          <Badge bg="warning" text="dark" style={{ marginLeft: ".5rem", fontSize: ".62rem" }}>
                            APP DOWN
                          </Badge>
                        )}
                      </span>
                      <Button
                        size="sm"
                        variant={bloqueada ? "outline-success" : "outline-danger"}
                        disabled={appsPanel.cargando}
                        onClick={() => alternarApp(idApp, !bloqueada)}
                      >
                        {bloqueada ? "Turn on" : "Turn off"}
                      </Button>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </Modal.Body>
        </Modal>

        <Modal
          show={modalInfo.show}
          onHide={handleCloseModal}
          animation={true}
          centered={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>{modalInfo.tittle}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {connectionError !== "" ? (
              <Alert variant="warning">{connectionError}</Alert>
            ) : (
              <></>
            )}
            {connectionSuccess !== "" ? (
              <Alert variant="success">{connectionSuccess}</Alert>
            ) : (
              <></>
            )}
            {modalInfo.body}
          </Modal.Body>
          <Modal.Footer>
            {connectionSuccess === "" ? (
              <>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Cancel
                </Button>

                <Button
                  variant="primary"
                  onClick={handlerActions}
                  disabled={showLoading}
                >
                  {showLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <></>
                  )}
                  Confirm
                </Button>
              </>
            ) : (
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  return (
    <>
      {usersTable()}
      {modalPopUp()}
      <AddUser
        show={showAddNewUSer}
        onCancel={handleCancelNewUser}
        onClose={() => {}}
        onFail={() => {}}
        onSuccess={() => {
          forceSearch();
        }}
      />
      <UpdatePassword
        userDefault={showUpdatePassword.user}
        show={showUpdatePassword.show}
        onCancel={handleCancelUpdatePassword}
        onClose={() => {}}
        onFail={() => {}}
        onSuccess={() => {
          forceSearch();
        }}
      />
      <UpdateApplications
        userDefault={showUpdateApplications.user}
        show={showUpdateApplications.show}
        onCancel={handleCancelUpdateApplications}
        onClose={() => {}}
        onFail={() => {}}
        onSuccess={() => {
          forceSearch();
        }}
      />
    </>
  );
}
